import React, { FunctionComponent, } from 'react';
import { ElementBase, IElementBaseProps, initializeElement } from '..';
import { onPatch } from 'mobx-state-tree';
import { useDebouncedCallback } from 'use-debounce';
import { conditionIsGo } from '../../utils/conditionIsGo';

export const GroupElement: FunctionComponent<IElementBaseProps> = ({ ...props }) => {
    const {
        itemsStore, element,
    } = initializeElement(props);
    const [show, setShow] = React.useState<boolean>(false);

    const fieldsRequired = React.useMemo(() => [].concat((element.dynamicRequires || [])
        .flatMap(require => require.conditions.flatMap(a => a.rules || a)))
        .concat(element.requires || []), [element.dynamicRequires, element.requires]);

    const checkCondition = React.useCallback(async () => {
        try {
            console.log(element.id, element.name,  "verifica condicion 2", "checkCondition")
            let missingCondition = false;
            const itemData = itemsStore.itemActive.toJSON();
            if (element.requires?.length > 0 && element.dynamicRequires?.length > 0) {
                element.dynamicRequires[0].options = true;
                const basicReqMissing = element.requires.some((req: any) =>
                    itemsStore.getPayloadElement(req.elementId, props.parentId, props.recordIdx).value !== req.expectedValue
                );
                const dynamicReqGo = conditionIsGo(element.dynamicRequires, itemData, props.parentId, props.recordIdx)[0] === true;
                missingCondition = basicReqMissing && !dynamicReqGo;
            }
            else if (element.requires?.length > 0) {
                missingCondition = element.requires.some((req: any) =>
                    itemsStore.getPayloadElement(req.elementId, props.parentId, props.recordIdx).value !== req.expectedValue
                );
            }
            else if (element.dynamicRequires?.length > 0) {
                element.dynamicRequires[0].options = true;
                missingCondition = !(conditionIsGo(element.dynamicRequires, itemData, props.parentId, props.recordIdx)[0] === true);
            }

            console.log(element.id, element.name, "verifica condicion 234", missingCondition)

            // 2. Optimización de recursión: Actualización masiva de hijos
            const dataToUpdate: any[] = [];
            const walk = (nodes: any[]) => {
                if (!nodes) return;
                for (let i = 0; i < nodes.length; i++) {
                    const node = nodes[i];
                    //if (["populate", "validate",].includes(node.type)) continue;
                    if (missingCondition !== true && node.type === "group") continue;
                    console.log(element.id, element.name, "verifica condicion ", node.id,node.name,"inactiveGroup",missingCondition)
                    dataToUpdate.push({
                        fieldId: node.id,
                        payloadElement: {
                            ...(!missingCondition && { value: itemsStore.getPayloadElement(node.id, props.parentId, props.recordIdx).value || node.templateData?.preset }),
                            ...(missingCondition && { value: null, readOnly: null }),
                            inactiveGroup: missingCondition
                        }
                    });

                    if (node.nodes) walk(node.nodes);
                }
            };
            if (element.nodes) {
                walk(element.nodes);

            }
            requestAnimationFrame(() => {
                itemsStore.updPayloadElements(dataToUpdate, props.parentId, props.recordIdx);
                setTimeout(()=>setShow(!(missingCondition)),100);

            });
            console.log(element.id, "verifica condicion 3 out", "checkCondition")
        } catch (e) {
            console.log("GroupElement", "checkCondition", "", element.id, e)
        }
    }, [element.id, element.requires, element.dynamicRequires, element.nodes, itemsStore, props.parentId, props.recordIdx]);
    const checkConditionDebounced = useDebouncedCallback(checkCondition, 100);

    React.useEffect(() => {
        checkConditionDebounced();
        const disposer = onPatch(itemsStore, patch => {
            if (patch.path.endsWith("/value")) {
                const isRelevant = fieldsRequired.some(req =>
                    patch.path.includes(req.elementId || req.fieldId)
                );
                if (isRelevant) checkConditionDebounced();
            }
        });
        return () => disposer();
    }, []);

    return <ElementBase borderTopWidth={0} alignItems={"center"} borderBottomWidth={0}
        element={element} changedMe={show}
        forReview={props.forReview} hideTitleBar={true} >
            {show ? props.children : <></>}
    </ElementBase>
}
